<template>
    <!-- 契約終了時に表示する既定メッセージ領域。契約終了ならこちらの div が表示される -->
    <div v-if="appData.terminatedContract" class="default-message" v-t="'message.error_contract_termination'">
    </div>

    <!-- 上記でない場合に表示されるメインのトーク画面パネル全体のラッパー -->
    <div v-else class="talk-panel">
        <div class="search-row">
                    <!-- 検索条件（日時・対象ユーザー/グループ）の入力エリア全体 -->
                    <div class="search">
                        <!-- 検索エリア内部の配置用コンテナ（レイアウト用） -->
                        <div class="serarch-contents">
                            <!-- 期間選択 UI。ベースブランチの [日付][時刻]~[時刻] を [日付 時刻]~[日付 時刻] に広げたもので、
                                 カレンダー・30分刻みの時刻プルダウンはそのまま使い、日をまたぐ範囲も指定できる。
                                 横幅を抑えるため日付と時刻は1つの枠に収め、日付部分をクリックするとカレンダー、
                                 時刻部分をクリックするとプルダウンが開く。
                                 範囲は常に24時間以内に保つ（超えたら変更していない側を自動調整してハイライトする） -->
                            <div class="datetime-range-picker">
                                <div class="datetime-field" :class="{ 'datetime-field-auto-adjusted': autoAdjustedField === 'start' }">
                                    <el-date-picker
                                        class="datetime-field-date"
                                        v-model="rangeStartDate"
                                        type="date"
                                        prefix-icon="noicon"
                                        clear-icon="noicon"
                                        :clearable="false"
                                        placeholder="">
                                    </el-date-picker>
                                    <span class="datetime-field-divider"></span>
                                    <el-time-select
                                        class="datetime-field-time"
                                        v-model="rangeStartTime"
                                        prefix-icon="noicon"
                                        clear-icon="noicon"
                                        :clearable="false"
                                        :picker-options="{start: '00:00', step: '00:30', end: '24:00'}"
                                        placeholder="">
                                    </el-time-select>
                                </div>
                                <span class="datetime-range-separator">~</span>
                                <div class="datetime-field" :class="{ 'datetime-field-auto-adjusted': autoAdjustedField === 'end' }">
                                    <el-date-picker
                                        class="datetime-field-date"
                                        v-model="rangeEndDate"
                                        type="date"
                                        prefix-icon="noicon"
                                        clear-icon="noicon"
                                        :clearable="false"
                                        placeholder="">
                                    </el-date-picker>
                                    <span class="datetime-field-divider"></span>
                                    <el-time-select
                                        class="datetime-field-time"
                                        v-model="rangeEndTime"
                                        prefix-icon="noicon"
                                        clear-icon="noicon"
                                        :clearable="false"
                                        :picker-options="{start: '00:00', step: '00:30', end: '24:00'}"
                                        placeholder="">
                                    </el-time-select>
                                </div>
                                <el-button size="small" class="today-button" v-on:click="setDateTimeRangeToday()" v-t="'message.action_talk_search_today'"></el-button>
                            </div>

                            <!-- 選択対象（トークグループ or P2P ユーザー）表示エリア全体 -->
                            <div class="display-target">
                                <!-- 選択中の対象タイプ（例: Group / User）をテキスト表示 -->
                                <span>{{ selectedItemType }}</span>

                                <!-- 選択済みタグ群の表示コンテナ。何か選択がある時のみ表示 -->
                                <div class="display-tags" v-if="selected.length > 0">

                                    <!-- トークグループ選択時の単一タグ表示（削除ボタン付き） -->
                                    <div class="selected-tag" v-if="isTalkgroup">
                                        <span>{{ selected[0].data.label }}</span>
                                        <span class="closeTag" @click="deleteUserTag(selected[0])">×</span>
                                    </div>

                                    <!-- P2P（ユーザー間）選択時のタグ表示エリア -->
                                    <div class="p2p-tags" v-else>
                                        <!-- 送信側（または一人目）のユーザータグ -->
                                        <div class="selected-tag">
                                            <span>{{ selected[0].data.label }}</span>
                                            <span class="closeTag" @click="deleteUserTag(selected[0])">×</span>
                                        </div>

                                        <!-- 相手ユーザー（2人目）が選択されている場合の表示。入れ替えボタンあり -->
                                        <div class="peer-user" v-if="selected.length == 2">
                                            <!-- 2ユーザーの入れ替えを行うボタン（双方向アイコン） -->
                                            <button class="transparent-button" @click="swapUserTag()"><img class="bidirectional" src="../../assets/icon_mutual.svg" alt=""></button>
                                            <!-- 受信側（または二人目）のユーザータグ -->
                                            <div class="selected-tag">
                                                <span>{{ selected[1].data.label }}</span>
                                                <span class="closeTag" @click="deleteUserTag(selected[1])">×</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        </div>

        <div class="talk-columns" ref="talkColumns">
            <!-- 左ペイン（オブジェクトツリー）領域。ドラッグで幅変更可 -->
            <div class="talk-column tree-column" :style="{ width: treeWidth + '%' }">
                <div class="inner-panel">
                    <div class="objectTree" v-if="showTree">
                        <talk-object-tree
                            :initialData="initialDataForTree"
                            :showAdminUser="false"
                            @on-selectnode="handleOnSelectNode"
                            ref="talkObjectTree">
                        </talk-object-tree>
                    </div>
                </div>
            </div>

            <div class="talk-column-splitter" v-on:mousedown="startResize($event, 'tree')"></div>

            <!-- 右ペイン（トークリスト）領域。ドラッグで幅変更可 -->
            <div class="talk-column talk-history-column" :style="{ width: talkHistoryWidth + '%' }">
                <!-- 内側パネル。ID はスクロール領域の高さ計測等に利用される想定 -->
                <div id="record-list-panel" class="inner-panel">
                    <!-- 縦方向スクロールを許可する領域。リストをスクロール表示 -->
                    <div class="scrollable">
                        <!-- トーク履歴一覧コンポーネント。検索条件や選択状態を受け取って一覧を表示 -->
                        <talk-right-pane
                            v-bind:selectedNode="selectedNode"
                            v-bind:appData="appData"
                            v-bind:isTalkgroup="isTalkgroup"
                            v-bind:fromDateTime="fromDateTime"
                            v-bind:toDateTime="toDateTime"
                            v-bind:languageIndex="languageIndex"
                            v-bind:selected="selected"
                            v-bind:selectedItemType="selectedItemType"
                            v-bind:summaryExpanded="summaryExpanded"
                            v-bind:summaryGenerating="summaryGenerating"
                            @toggle-summary="toggleSummary"
                            @collapse-summary="collapseSummary"
                            @language-change="languageIndex = $event"
                            @summary-target-change="handleSummaryTargetChange"
                            @open-summary-generate="summaryGenerateDialogVisible = true"
                            @active-tab-change="activeTalkTabName = $event">
                        </talk-right-pane>
                    </div>
                </div>
            </div>

            <template v-if="summaryExpanded && summaryHistoryAppEnabled">
                <div class="talk-column-splitter" v-on:mousedown="startResize($event, 'summary')"></div>

                <!-- 要約履歴パネル。閉じるボタンはパネル自身の見出し（SummaryHistoryList）に持たせている。ドラッグで幅変更可 -->
                <div class="talk-column summary-column" :style="{ width: summaryWidth + '%' }">
                    <div class="inner-panel">
                        <summary-history-list
                            ref="summaryHistoryList"
                            v-bind:appData="appData"
                            v-bind:selected="selected"
                            v-bind:isTalkgroup="isTalkgroup"
                            v-bind:fromDateTime="fromDateTime"
                            v-bind:toDateTime="toDateTime"
                            @toggle-summary="toggleSummary">
                        </summary-history-list>
                    </div>
                </div>
            </template>
        </div>

        <!-- 要約の作成条件をモーダルで選ばせる。作成開始と同時に閉じ、実際の生成は背後で進む -->
        <summary-generate-dialog
            v-if="summaryGenerateDialogVisible"
            v-bind:appData="appData"
            v-bind:selected="selected"
            v-bind:isTalkgroup="isTalkgroup"
            v-bind:languageIndex="languageIndex"
            v-bind:selection="summarySelection"
            @close="summaryGenerateDialogVisible = false"
            @start-generate="startSummaryGenerate">
        </summary-generate-dialog>
    </div>
</template>

<script>
import constants from "@/components/constants.js";
import commonUtil from "@/components/commonutil.js";
import server from "@/components/ServerApi.js";
import TalkObjectTree from "./TalkObjectTree.vue";
import TalkRightPane from "./TalkRightPane.vue";
import SummaryHistoryList from "./SummaryHistoryList.vue";
import SummaryGenerateDialog from "./SummaryGenerateDialog.vue";

const MIN_COLUMN_WIDTH_PERCENT = 10;
// ツリー列の既定幅。見出し（階層ID / ユーザーID/表示名 / グループ表示名 + 検索ボタン）が
// 収まらない画面幅ではこの値を下限として広げるが、広げすぎないよう上限も置く
const DEFAULT_TREE_WIDTH_PERCENT = 20;
const MAX_DEFAULT_TREE_WIDTH_PERCENT = 50;

const MAX_SEARCH_RANGE_MS = 24 * 60 * 60 * 1000;

// AIサーバーの SseError と対応するエラーメッセージ
const SUMMARY_ERROR_MESSAGE_KEY_BY_CODE = {
    3: "error_summary_no_records",
    4: "error_summary_over_records",
    5: "error_summary_over_text",
};

function todayAtMidnight() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
}

export default {
    data () {
        return {
          // 日時範囲。開始・終了それぞれ日付(Date)と時刻('HH:mm'。'24:00' は翌日0時)で持ち、
          // ベースブランチの [日付][時刻]~[時刻] と同じ表現で日またぎだけ許す。範囲は常に24時間以内に保つ
          rangeStartDate: todayAtMidnight(),
          rangeStartTime: '00:00',
          rangeEndDate: todayAtMidnight(),
          rangeEndTime: '24:00',
          // 24時間を超えたため自動調整された側('start'|'end')。一時的にハイライト表示して気づけるようにする
          autoAdjustedField: null,
          autoAdjustedHighlightTimer: null,
          selected: [],
          isTalkgroup: false,
          showTree: true,
          selectedItemType: null,
          languageIndex: 0,
          selectedNode: null, // ← 追加
          // Local mirrors of BuddyComCall flags to react to App.vue updates
          enableBuddyComCall: false,
          enableBuddyComCallTrial: false,
          exportTenants: [],
          // 3カラムレイアウトの幅（%）。要約履歴が閉じている間は tree/talkHistory の2カラムのみ使用
          treeWidth: DEFAULT_TREE_WIDTH_PERCENT,
          talkHistoryWidth: 100 - DEFAULT_TREE_WIDTH_PERCENT,
          // ユーザーがツリー/トーク境界をドラッグしたら、以降はウィンドウリサイズでの自動調整をしない
          treeWidthUserAdjusted: false,
          summaryWidth: 40,
          summaryExpanded: false,
          // 発話履歴でチェックされている範囲。要約ダイアログの対象に渡す
          summarySelection: null,
          summaryGenerateDialogVisible: false,
          // 要約の生成が進行中かどうか。モーダル(summaryGenerateDialogVisible)とは独立していて、
          // ダイアログを閉じたあとも右下ポップアップの表示や TalkrecordList 側の二重実行防止に使われる
          summaryGenerating: false,
          // 要約作成中/完了を知らせる右下ポップアップ(el-notification)のインスタンス。生成中→完了で
          // 同じ枠を差し替えるため、次のポップアップを出す前や破棄時に明示的に close() する
          summaryPopupInstance: null,
          // TalkRightPane 側で選択中のタブ名('talkRecord' | 'BuddycomCallRecord')。要約履歴は
          // talkRecord タブでのみ扱うため、完了ポップアップのクリックで詳細を開いてよいかの判定に使う
          activeTalkTabName: 'talkRecord',
          // 完了ポップアップのクリックで自分自身が /talk へ push した直後の1回だけ、
          // $route watcher によるツリー選択リセットを抑止するためのフラグ
          suppressNextRouteReset: false,
          // ドラッグリサイズ中の内部状態。'tree' = ツリー/トーク境界、'summary' = トーク/要約境界
          resizingSplitter: null,
          dragStartX: 0,
          dragStartWidths: null,
        }
    },
    computed: {
        tenantList() {
            return [
                ...(this.appData.tenantList[0] ? [this.appData.tenantList[0]] : []),
                ...this.exportTenants
                    .filter(t => (t.c2cOption & constants.C2C_OPTION.VIEW_GROUP_TALK_RECORD) !== 0)
                    .map(t => ({
                        tenantId: t.tenantId,
                        id: 1,
                        label: t.tenantName,
                        name: t.tenantName,
                        type: 0,
                        isLeaf: false,
                        connectUserId: t.wantUserId,
                    })),
            ];
        },
        initialDataForTree() {
            return this.tenantList;
        },
        summaryHistoryAppEnabled() {
            return commonUtil.isSummaryHistoryEnabled(this.appData.apps);
        },
        // 開始・終了それぞれの日付+時刻から算出する。子コンポーネント（TalkRightPane等）へは常にこの2つの日時として渡す
        fromDateTime() {
            return this.combineDateTime(this.rangeStartDate, this.rangeStartTime);
        },
        toDateTime() {
            return this.combineDateTime(this.rangeEndDate, this.rangeEndTime);
        },
    },
    methods: {
        // date(日付部分だけ使う) + timeStr('HH:mm'。'24:00' は Date コンストラクタの時刻オーバーフロー
        // 正規化にまかせて翌日0時として扱う) を1つの日時にまとめる
        combineDateTime(date, timeStr) {
            const [hh, mm] = timeStr.split(':').map(Number);
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hh, mm);
        },
        formatTimeOnly(date) {
            const pad = (n) => String(n).padStart(2, '0');
            return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
        },
        // 24時間を超えたために自動調整された側を一時的にハイライトし、少ししたら消す
        flagAutoAdjusted(field) {
            this.autoAdjustedField = field;
            if (this.autoAdjustedHighlightTimer) {
                clearTimeout(this.autoAdjustedHighlightTimer);
            }
            this.autoAdjustedHighlightTimer = setTimeout(() => {
                this.autoAdjustedField = null;
                this.autoAdjustedHighlightTimer = null;
            }, 2000);
        },
        // 24時間超過の自動調整で、指定側の日付・時刻を絶対日時から書き戻す。
        // 翌日0時は '24:00' でなく翌日の '00:00' として表現する
        applyAdjustedDateTime(side, dateTime) {
            const dateKey = side === 'start' ? 'rangeStartDate' : 'rangeEndDate';
            const timeKey = side === 'start' ? 'rangeStartTime' : 'rangeEndTime';
            this[dateKey] = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
            this[timeKey] = this.formatTimeOnly(dateTime);
        },
        // 開始・終了を「今日 00:00 〜 今日 24:00」にリセットする
        setDateTimeRangeToday() {
            this.rangeStartDate = todayAtMidnight();
            this.rangeStartTime = '00:00';
            this.rangeEndDate = todayAtMidnight();
            this.rangeEndTime = '24:00';
        },
        handleOnSelectNode(elnode) {
            // 要約履歴はグループ選択時のみ対応。パネルを開いたままグループ以外のノードを
            // クリックしたら、開いたままにせずパネルを閉じる
            if (elnode.node.data.type !== constants.OBJECT_TALKGROUP) {
                this.collapseSummary();
            }
            switch (elnode.node.data.type) {
                case constants.OBJECT_NODE:
                    return;
                case constants.OBJECT_USER:
                case constants.OBJECT_ASSISTANT:
                case constants.OBJECT_CUSTOM_ASSISTANT:
                case constants.OBJECT_IP_RADIO:
                    if (this.isTalkgroup) {
                        this.selected = [];
                        this.isTalkgroup = false;
                        this.selectedItemType = "";
                    }

                    if (this.selected.length == 0) {
                        this.selectedItemType = commonUtil.getMessageText(this.$i18n,"item_user");
                        this.selected.push(elnode.node);
                    } else if (this.selected.length == 1) {
                        if (this.selected[0] !== elnode.node) {
                            this.selected.push(elnode.node);
                        }
                    } else if (this.selected.length == 2) {
                        if (this.selected[0] == elnode.node) {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_select_same_user"));
                            return;
                        }
                        this.selected.splice(1,1);
                        this.selected.push(elnode.node);
                    }
                    return;
                case constants.OBJECT_TALKGROUP:
                    this.selected = [];
                    this.selectedItemType = commonUtil.getMessageText(this.$i18n, "item_group");
                    this.selected.push(elnode.node);
                    this.isTalkgroup = true;
                    this.selectedNode = elnode; // ← 追加: これがないと getInfo() が動かない
                    return;
            }
        },
        swapUserTag() {
            this.selected.splice(0, 2, this.selected[1], this.selected[0]);
        },
        deleteUserTag(node) {
            var self = this;
            this.selected.some(function(value, i){
                if (value == node) {
                    self.selected.splice(i, 1);
                }
                if (self.selected.length == 0) {
                    self.selectedItemType = "";
                }
            });
        },
        setLanguageIndex() {
            let countryCode = this.appData.countryCodeAlpha3;
            let language = commonUtil.getLanguageIndexList(this.$i18n.locale).filter(function (item) {
                if (item.countryCode.indexOf(countryCode) >= 0) return true;
            });
            if (language.length == 0) {
                this.languageIndex = 2;
            } else {
                this.languageIndex = language[0].value;
            }
        },
        async getTenantConnectInfo() {
            const REQUEST_TENANT_INFO = 0;
            try {
                const res = await server.post('/gettenantconnectinfo', {type: REQUEST_TENANT_INFO});
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.exportTenants.push(...res.data.exportTenantList);
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getTenantConnectInfo").replace("{code}", res.data.status));
                        break;
                }
            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getTenantConnectInfo", e);
            }
        },
        resetSelectedNode() {
          this.selectedNode = null;
        },
        toggleSummary() {
            this.summaryExpanded = !this.summaryExpanded;
            if (this.summaryExpanded) {
                const remaining = 100 - this.treeWidth;
                this.talkHistoryWidth = remaining / 2;
                this.summaryWidth = remaining / 2;
            } else {
                this.talkHistoryWidth = 100 - this.treeWidth;
            }
        },
        collapseSummary() {
            if (!this.summaryExpanded) return;
            this.summaryExpanded = false;
            this.talkHistoryWidth = 100 - this.treeWidth;
        },
        handleSummaryTargetChange(target) {
            this.summarySelection = target ? target.selection : null;
        },
        closeSummaryPopup() {
            if (this.summaryPopupInstance) {
                this.summaryPopupInstance.close();
                this.summaryPopupInstance = null;
            }
        },
        showSummaryGeneratingPopup() {
            this.closeSummaryPopup();
            this.summaryPopupInstance = this.$notify({
                title: commonUtil.getMessageText(this.$i18n, "title_summary_generate"),
                message: commonUtil.getMessageText(this.$i18n, "info_summary_generating"),
                position: "bottom-right",
                duration: 0,
                showClose: false,
                iconClass: "el-icon-loading",
            });
        },
        // 完了ポップアップはクリックされるまでは通知のままにし、クリック時にだけ要約履歴ペインを
        // 開いて詳細を表示する（強制遷移はしない）
        showSummaryGeneratedPopup(record) {
            this.closeSummaryPopup();
            this.summaryPopupInstance = this.$notify({
                title: commonUtil.getMessageText(this.$i18n, "info_summary_generated"),
                message: commonUtil.getMessageText(this.$i18n, "info_summary_generated_popup_hint"),
                position: "bottom-right",
                duration: 0,
                type: "success",
                customClass: "summary-generate-popup-done",
                onClick: () => {
                    this.closeSummaryPopup();
                    this.openGeneratedSummaryDetail(record);
                },
            });
        },
        // 要約履歴ペインを開き、生成された要約の詳細ダイアログを表示する。完了ポップアップの
        // クリック時のみ呼ばれる（生成完了そのものでは呼ばない＝強制遷移しない）。
        // トーク履歴ページ以外（他メニューのページ）にいる場合は /talk へ遷移してから開く。
        // Talk.vue は keep-alive で常駐しているため、他タブ(BuddycomCall)にいる間は
        // 要約履歴を扱わない仕様に合わせ、ポップアップをクリックしても遷移させない
        openGeneratedSummaryDetail(record) {
            if (this.activeTalkTabName !== 'talkRecord') {
                return;
            }
            const openAfterRouteReady = () => {
                if (!this.summaryExpanded) {
                    this.toggleSummary();
                }
                this.$nextTick(() => {
                    if (this.$refs.summaryHistoryList) {
                        this.$refs.summaryHistoryList.showGenerated(record);
                    }
                });
            };
            if (this.$route.name !== 'Talk') {
                // 遷移直後に $route watcher がツリー選択をリセットしてしまうと
                // 表示対象のグループが分からなくなるため、この1回だけ抑止する
                this.suppressNextRouteReset = true;
                // push の完了（ルート遷移確定・kept-alive な Talk.vue の再アクティブ化）を待たずに
                // 進めると、他画面滞在中は summaryHistoryList がまだ描画木に無く
                // $refs.summaryHistoryList が取得できないことがある
                let navigationFailed = false;
                this.$router.push('/talk')
                    .catch(() => {
                        // 重複遷移(NavigationDuplicated)等で reject された場合、$route watcher 側の
                        // リセットは走らないため、抑止フラグを残したままだと次回の通常遷移で
                        // リセットが誤ってスキップされる。vue-router のエラー通知は他の遷移箇所でも
                        // 行っていない(fire-and-forget)ため、ここでもポップアップは出さない
                        navigationFailed = true;
                        this.suppressNextRouteReset = false;
                    })
                    .then(() => {
                        if (!navigationFailed) {
                            openAfterRouteReady();
                        }
                    });
                return;
            }
            openAfterRouteReady();
        },
        // SummaryGenerateDialog から生成条件を受け取り、モーダルを閉じてバックグラウンドで生成を進める。
        // 進行中・完了は画面右下のポップアップ（el-notification）で知らせ続けるので、ここが動いている間も
        // 他の操作（グループ切替・発話履歴の閲覧など）はブロックしないが、要約の生成自体は並行実行させない
        // （TalkrecordList 側で選択モードへの再入も止めているが、ここでも二重に防ぐ）
        async startSummaryGenerate(payload) {
            if (this.summaryGenerating) return;
            this.summaryGenerateDialogVisible = false;
            this.summaryGenerating = true;
            this.showSummaryGeneratingPopup();

            try {
                const data = await server.aiSse(
                    payload.aiServerBaseUrl,
                    "/console/summary/generate/sse",
                    payload.requestBody,
                    payload.tenantId
                );
                this.showSummaryGeneratedPopup(data);
            } catch (error) {
                this.closeSummaryPopup();
                commonUtil.putExceptionErrorMessage(this, "generateSummary", error);
                const messageKey = SUMMARY_ERROR_MESSAGE_KEY_BY_CODE[error && error.sseErrorCode] || "error_summary_failed";
                commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, messageKey));
            } finally {
                this.summaryGenerating = false;
            }
        },
        // ツリー列の見出し行が見切れないよう、既定幅(20%)を下限にして必要なら広げる。
        // 見出し左側(float)と右側の検索ボタンは内容幅で測れるので、その合計 + 余白を必要 px とする
        fitTreeWidthToHeader() {
            if (this.treeWidthUserAdjusted || !this.$refs.talkColumns) {
                return;
            }
            const containerWidth = this.$refs.talkColumns.getBoundingClientRect().width;
            const headerLeft = this.$refs.talkColumns.querySelector('.tree-header-left');
            if (containerWidth <= 0 || !headerLeft) {
                return;
            }
            const headerButton = this.$refs.talkColumns.querySelector('.tree-header-right .tree-command-button');
            const HEADER_RIGHT_PADDING = 20;
            const HEADER_GAP = 12;
            const neededPx = headerLeft.offsetWidth
                + (headerButton ? headerButton.offsetWidth + HEADER_RIGHT_PADDING : 0)
                + HEADER_GAP;
            const neededPercent = (neededPx / containerWidth) * 100;
            const newTree = Math.min(MAX_DEFAULT_TREE_WIDTH_PERCENT, Math.max(DEFAULT_TREE_WIDTH_PERCENT, neededPercent));
            const fixedSummary = this.summaryExpanded ? this.summaryWidth : 0;
            this.treeWidth = newTree;
            this.talkHistoryWidth = 100 - fixedSummary - newTree;
        },
        handleWindowResize() {
            this.fitTreeWidthToHeader();
        },
        startResize(evt, splitter) {
            this.resizingSplitter = splitter;
            this.dragStartX = evt.clientX;
            this.dragStartWidths = {
                tree: this.treeWidth,
                talk: this.talkHistoryWidth,
                summary: this.summaryWidth,
            };
            document.addEventListener('mousemove', this.onResizeMove);
            document.addEventListener('mouseup', this.stopResize);
            evt.preventDefault();
        },
        onResizeMove(evt) {
            if (!this.resizingSplitter || !this.$refs.talkColumns) return;
            const containerWidth = this.$refs.talkColumns.getBoundingClientRect().width;
            if (containerWidth <= 0) return;
            const deltaPercent = ((evt.clientX - this.dragStartX) / containerWidth) * 100;

            if (this.resizingSplitter === 'tree') {
                this.treeWidthUserAdjusted = true;
                const fixedSummary = this.summaryExpanded ? this.dragStartWidths.summary : 0;
                const movableTotal = this.dragStartWidths.tree + this.dragStartWidths.talk;
                let newTree = this.dragStartWidths.tree + deltaPercent;
                newTree = Math.max(MIN_COLUMN_WIDTH_PERCENT, Math.min(newTree, movableTotal - MIN_COLUMN_WIDTH_PERCENT));
                this.treeWidth = newTree;
                this.talkHistoryWidth = 100 - fixedSummary - newTree;
            } else if (this.resizingSplitter === 'summary') {
                const movableTotal = this.dragStartWidths.talk + this.dragStartWidths.summary;
                let newTalk = this.dragStartWidths.talk + deltaPercent;
                newTalk = Math.max(MIN_COLUMN_WIDTH_PERCENT, Math.min(newTalk, movableTotal - MIN_COLUMN_WIDTH_PERCENT));
                this.talkHistoryWidth = newTalk;
                this.summaryWidth = movableTotal - newTalk;
            }
        },
        stopResize() {
            this.resizingSplitter = null;
            document.removeEventListener('mousemove', this.onResizeMove);
            document.removeEventListener('mouseup', this.stopResize);
        },
    },
    created () {
        this.setLanguageIndex();
        // Initialize local mirrors for BuddyComCall flags
        if (this.appData) {
            this.enableBuddyComCall = !!this.appData.enableBuddyComCall;
            this.enableBuddyComCallTrial = !!this.appData.enableBuddyComCallTrial;
        }
    },
    async mounted() {
        this.$nextTick(() => this.fitTreeWidthToHeader());
        window.addEventListener('resize', this.handleWindowResize);
        await this.getTenantConnectInfo();
    },
    beforeDestroy() {
        // ドラッグ中にコンポーネントが破棄された場合に備えて確実にリスナーを外す
        document.removeEventListener('mousemove', this.onResizeMove);
        document.removeEventListener('mouseup', this.stopResize);
        window.removeEventListener('resize', this.handleWindowResize);
        if (this.autoAdjustedHighlightTimer) {
            clearTimeout(this.autoAdjustedHighlightTimer);
        }
        this.closeSummaryPopup();
    },
    components: {
        TalkObjectTree,
        TalkRightPane,
        SummaryHistoryList,
        SummaryGenerateDialog,
    },
    watch: {
        'appData.tenantList'() {
            this.showTree = false;
            this.$nextTick(() => {
                this.showTree = true;
                this.setLanguageIndex();
            });
        },
        tenantList() {
            this.showTree = false;
            this.$nextTick(() => {
                this.showTree = true;
                this.setLanguageIndex();
            });
        },
        // React to App.vue toggling BuddyComCall feature flags
        'appData.enableBuddyComCall'(val) { this.enableBuddyComCall = !!val; },
        'appData.enableBuddyComCallTrial'(val) { this.enableBuddyComCallTrial = !!val; },
        '$route' (to) {
            if (to.name == "Talk") {
                // 完了ポップアップのクリックによる自己遷移の直後は、表示対象のグループ選択を
                // 保つためこのリセットを1回だけスキップする
                if (this.suppressNextRouteReset) {
                    this.suppressNextRouteReset = false;
                    return;
                }
                this.$refs.talkObjectTree.resetCurrentNode(true);
                this.selected = [];
                this.setDateTimeRangeToday();
                this.selectedItemType = null;
            }
        },
        // 開始または終了を設定して24時間を超える（または終了が開始より前になる）範囲になった場合、
        // 変更していない方を動かして常に24時間以内に収める（変更した側の値は尊重する）。
        // 開始側の watcher が終了を動かすと終了側の watcher も走るが、その時点で差は丁度24時間なので何もしない
        fromDateTime(newVal, oldVal) {
            if (!oldVal || newVal.getTime() === oldVal.getTime()) {
                return;
            }
            const diffMs = this.toDateTime.getTime() - newVal.getTime();
            if (diffMs > MAX_SEARCH_RANGE_MS || diffMs < 0) {
                this.flagAutoAdjusted('end');
                this.applyAdjustedDateTime('end', new Date(newVal.getTime() + MAX_SEARCH_RANGE_MS));
            }
        },
        toDateTime(newVal, oldVal) {
            if (!oldVal || newVal.getTime() === oldVal.getTime()) {
                return;
            }
            const diffMs = newVal.getTime() - this.fromDateTime.getTime();
            if (diffMs > MAX_SEARCH_RANGE_MS || diffMs < 0) {
                this.flagAutoAdjusted('start');
                this.applyAdjustedDateTime('start', new Date(newVal.getTime() - MAX_SEARCH_RANGE_MS));
            }
        },
    },
    props: ['appData']
}
</script>

<style scoped>

.talk-panel {
    height: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
}

.search-row {
    flex: 0 0 auto;
}

.talk-columns {
    flex: 1;
    display: flex;
    min-height: 0;
    min-width: 0;
    border-top: 1px solid #eeeeee;
}

.talk-column {
    height: 100%;
    min-height: 0;
    min-width: 0;
    box-sizing: border-box;
    overflow: hidden;
}

.talk-column-splitter {
    flex: 0 0 6px;
    min-width: 6px;
    cursor: col-resize;
    position: relative;
}
.talk-column-splitter::after {
    content: '';
    position: absolute;
    left: 2px;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: #eeeeee;
}
.talk-column-splitter:hover::after {
    background-color: #5171cb;
}

.inner-panel {
    position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: #ffffff;
}

.summary-column .inner-panel {
    display: flex;
    flex-direction: column;
}

.scrollable {
    width: 100%;
    height: 100%;
    min-width: 0;
}

select {
    height: 40px;
}

.search {
    width: 100%;
    background-color: #ecf1fa;
    display: table;
}

.serarch-contents {
    display: table-cell;
    vertical-align:middle;
}

/* 日付/時刻ピッカー（ベースブランチと同じアイコン付き入力） */
.date-picker {
    display: inline-block;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.time-picker {
    display: inline-block;
    padding-left: 20px;
}

.date-picker >>> .el-input__inner {
    background-image:url('../../assets/icon_calendar.svg');
    background-repeat:no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 35px;
}

.date-picker > .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 140px;
}

.time-picker >>> .el-input__inner {
    background-image:url('../../assets/icon_clock.svg');
    background-repeat:no-repeat;
    background-position-x: 10px;
    background-position-y: center;
    background-size: 16px 16px;
    height: 35px;
}

.time-picker > .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100px;
}

/* 日時範囲ピッカー。日付/時刻の各コントロールは上の .date-picker / .time-picker の見た目をそのまま使う */
.datetime-range-picker {
    display: inline-flex;
    align-items: center;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

/* 日付と時刻を1つの枠に収める。枠線は外側の div が持ち、中の2つの入力は枠線なしで並べる */
.datetime-field {
    display: inline-flex;
    align-items: center;
    height: 35px;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #ffffff;
    transition: background-color 1s ease, border-color 1s ease;
}
/* 24時間を超えたため自動調整された側を一時的に目立たせる。flagAutoAdjusted() が
   クラスを外すタイミングで上の transition により元の見た目へ滑らかに戻る */
.datetime-field-auto-adjusted {
    background-color: #fff6da;
    border-color: #e6a23c;
}
.datetime-field >>> .el-input__inner {
    height: 33px;
    line-height: 33px;
    border: none;
    background-color: transparent;
    font-size: 13px;
    color: #333b48;
}
.datetime-field-date.el-date-editor.el-input {
    width: 124px;
}
.datetime-field-date >>> .el-input__inner {
    background-image: url('../../assets/icon_calendar.svg');
    background-repeat: no-repeat;
    background-position: 8px center;
    background-size: 16px 16px;
    padding: 0 4px 0 30px;
    text-align: left;
}
.datetime-field-divider {
    width: 1px;
    height: 20px;
    background-color: #dcdfe6;
}
.datetime-field-time.el-date-editor.el-input {
    width: 60px;
}
.datetime-field-time >>> .el-input__inner {
    padding: 0 6px;
    text-align: center;
}

.datetime-range-separator {
    padding: 0 8px;
    color: #848991;
}

.today-button {
    margin-left: 12px;
}

.display-target {
    display: inline-block;
    padding-left: 20px;
}

.display-tags {
    display: inline-block;
}

.p2p-tags {
    display: inline-block;
}

.peer-user {
    display: inline-block;
}

.selected-tag {
    display: inline-block;
    border: 1px solid;
    border-radius: 30px;
    border-color: #5171cb;
    background-color: #ffffff;
    color: #5171cb;
    margin: 5px;
    padding: 6px;
    padding-left: 10px;
}
.selected-tag > .closeTag {
    cursor: pointer;
    border-radius: 4px;
    margin: 4px;
}
.selected-tag > .closeTag:active {
    background-color: gray;
}

.el-input--prefix .el-input__inner {
    padding: 0 8px !important;
    text-align: center !important;
}

/* 右ペインの外側（id="record-list-panel"）はスクロールさせない */
#record-list-panel {
    overflow: hidden;
}

/* 右ペイン内の .scrollable もスクロールさせない */
#record-list-panel .scrollable {
    overflow: hidden;
    display: flex;
    min-height: 0;
    min-width: 0;
}

#record-list-panel .scrollable > * {
    flex: 1;
    min-height: 0;
    min-width: 0;
}

</style>

<!-- el-notification は document.body 直下にマウントされ scoped 属性の外側になるため、
     クリック可能であることを示すカーソルだけこの非scopedブロックで当てる -->
<style>
.summary-generate-popup-done {
    cursor: pointer;
}
</style>
